import gql from 'graphql-tag';

const CLUB_DOCUMENT= gql`
query clubDocument($id: ID!){
  clubDocument(id: $id)  {
   files{
    downloadUrl
  },
  name,
  type,
  validFrom,
  validTo,
  createdAt
  }
}
`;

export default CLUB_DOCUMENT;